import Player from "../objects/player";

export default class MovementController { 
    public scene: Phaser.Scene;
    public target: Player;
    public speed: number = 0;
    public tspeed: number = 0;
    public kspeed: number = 0;
    

    // movement related variables
    private _isTouchInProgress: boolean = false;
    private _touchFlag: boolean = false;
    private _moveStartX: number = 0;
    private _keyDownFlag: boolean = false;
    private _dragPauseTimer = 100;
    private _directionKeys: any;
    private _angleTween: Phaser.Tweens.Tween;
    private _swayFactor: number;

    private _pan: {
        active: boolean,
        left: {
            in: number, out: number
        },
        right: number,
        center: number,
    }

    private _boundary: {
        l: number, r: number
    }


    constructor(scene, target){
        this.scene = scene;
        this.target = target;
        
        this._swayFactor = 0.0009;
        // this._initInput();
    }

    private _initInput(): void {
        // this._touchFlag = window.constants["MOBILE_FLAG"];
        this._touchFlag = true;
        if(this._touchFlag) {
            this.scene.input.addListener('pointerdown', this._touchStart.bind(this));
            this.scene.input.addListener('pointerup', this._touchEnd.bind(this));
            this.scene.input.addListener('pointermove', this._handleTouchMove.bind(this));

        }
        else {
            if(this.scene.input.keyboard) {
                this._directionKeys = this.scene.input.keyboard.addKeys('LEFT,RIGHT,FOUR,SIX');
            }

        }
        // console.log(this._directionKeys);

        this.kspeed = window.constants.DATA.speed[this.target.tag+"_key"]; 
        this.tspeed = window.constants.DATA.speed[this.target.tag+"_touch"];
        this._angleTween = this.scene.add.tween({
            targets: this.target,
            angle: { from: this.target.angle, to: 0 },
            // callbackScope: this,
            // onComplete: function(){},
            ease: 'Linear',       // 'Cubic', 'Elastic', 'Bounce', 'Back'
            duration: 100,
            repeat: 0,            // -1: infinity
            yoyo: false
        });
        
        let width = Math.floor(this.target.car.width * 0.5);
        this._pan = {
            active: false,
            left: {
                in: (this.target.boundary.l + width),
                out: (window.constants["CAMERA_BOUND"]) + width
            } ,
            right: Math.floor(this.target.boundary.r - (width * 2)), 
            center: window.constants["BASE_WIDTH"] * 0.5
        }

        this._boundary = {
            l: this.target.boundary.l + width,
            r: this.target.boundary.r - width
        }
        
    }

    private _removeEvents() {
        if(this._touchFlag) {
            this.scene.input.removeListener('pointerdown', this._touchStart.bind(this));
            this.scene.input.removeListener('pointerup', this._touchEnd.bind(this));
            this.scene.input.removeListener('pointermove', this._handleTouchMove.bind(this));
        }
    }

    private _touchStart(pointer) {
        if(window.constants["GAME_START"]){
            if (!this._isTouchInProgress) {
                this._isTouchInProgress = true;
                this._moveStartX = pointer.x;
            }
            this._dragPauseTimer = 0;
            this.speed = this.tspeed;
        }
    }

    private _touchEnd(pointer) {
        if(window.constants["GAME_START"]){
            this._isTouchInProgress = false;
            this._dragPauseTimer = 100;
            this._handleRotationTween();
        }
    }

    private _handleTouchMove(pointer) {
        if(window.constants["GAME_START"]){
            if(this.target.health > 0) {
                let newPos = Math.min(Math.max(this.target.x - ((this._moveStartX - pointer.x) * this.tspeed), this.target.boundary.l), this.target.boundary.r);
                if(this.target.x == newPos) {
                    if(this.target.angle != 0) {
                        if(!this._angleTween.isPlaying) {
                            this._handleRotationTween();
                        }
                    }
                } else {
                    this.target.x = newPos;
                    this.target.angle = Math.min(12, Math.max(-12, this.target.angle - ((this._moveStartX - pointer.x)*0.033))); // 0.33 is a conversion factor for distance to angle. i.e base_width -> 1080 / 3 = 360 and 1/3 = 0.33
                    // console.log(this.target.angle);
                    this._moveStartX = pointer.x;
                    this._dragPauseTimer = 0;
                }
            }
        }
    }

    private _handleRotationTween() {
        this._angleTween.stop();
        this.scene.tweens.remove(this._angleTween);
        this._angleTween = this.scene.add.tween({
            targets: this.target,
            angle: { from: this.target.angle, to: 0 },
            callbackScope: this,
            onComplete: function(){this.target.angle = 0;},
            ease: 'Linear',       // 'Cubic', 'Elastic', 'Bounce', 'Back'
            duration: 150 ,
            repeat: 0,            // -1: infinity
            yoyo: false
        });
        this._dragPauseTimer = 0;
        
    }

    

    private _handleMovement(time, dt) {
        if(this.target.health) {
            if ((this._directionKeys["LEFT"].isDown || this._directionKeys["FOUR"].isDown)) {
                this._keyDownFlag = true;
                let newPos = Math.max(this.target.boundary.l, this.target.x - this.kspeed);
                if(this.target.x == newPos) {
                    if(this.target.angle != 0) {
                        if(!this._angleTween.isPlaying()) {
                            this._handleRotationTween();
                        }
                    }
                } else {
                    this.target.x = newPos;
                    this.target.angle = Math.min(12, Math.max(-12, this.target.angle - ((this.target.x - this.kspeed) * this._swayFactor))); // 0.33 is a conversion factor for distance to angle. i.e base_width -> 1080 / 3 = 360 and 1/3 = 0.33
                    this.speed = this.kspeed;
                    if(!this._pan.active){
                        if(this.target.x < this._pan.left.in) {
                            if(this.scene.cameras.main.scrollX > -5) {
                                this.scene.cameras.main.pan(window.constants["CAMERA_BOUND"], 0, 200, 'Linear', false, this._handlePan, this );
                                this._pan.active = true;
                            }
                        } 
                        else if(this.target.x >= this._pan.right) {
                            if(this.scene.cameras.main.scrollX > ((-1*window.constants["CAMERA_BOUND"]) - 5)) {
                                this.scene.cameras.main.pan(window.constants["BASE_WIDTH"] * 0.5, 0, 150, 'Linear', false, this._handlePan, this );
                                this._pan.active = true;
                            }
                        }
                    }
                } 
            }
            else if ((this._directionKeys["RIGHT"].isDown || this._directionKeys["SIX"].isDown)) {
                this._keyDownFlag = true;
                let newPos = Math.min(this.target.boundary.r, this.target.x + this.kspeed);
                if(this.target.x == newPos) {
                    if(this.target.angle != 0) {
                        if(!this._angleTween.isPlaying()) {
                            this._handleRotationTween();
                        }
                    }
                } else {
                    this.target.x = newPos;
                    this.target.angle = Math.min(12, Math.max(-12, this.target.angle + ((this.target.x + this.kspeed) * this._swayFactor))); // 0.33 is a conversion factor for distance to angle. i.e base_width -> 1080 / 3 = 360 and 1/3 = 0.33
                    this.speed = this.kspeed;
                    if(!this._pan.active) {
                        if(this.target.x > this._pan.right) {
                            if(this.scene.cameras.main.scrollX < (-1*window.constants["CAMERA_BOUND"])) {
                                this.scene.cameras.main.pan(this.target.boundary.r + 16, 0, 200, 'Linear', false, this._handlePan, this );
                                this._pan.active = true;
                            }
                        } 
                        else if(this.scene.cameras.main.scrollX < this._pan.left.out) {
                            if(this.target.x > (this.target.boundary.l + 5)) {
                                this.scene.cameras.main.pan(window.constants["BASE_WIDTH"] * 0.5, 0, 150, 'Linear', false, this._handlePan, this );
                                this._pan.active = true;
                            }
                        }
                    }
                }
            }
            else {
                if(this._keyDownFlag) {
                    this._handleRotationTween();
                    this._keyDownFlag = false;
                }
            }
        }
    }

    private _handlePan(cam, progress) {
        if(progress == 1) {
            this._pan.active = false;
        }
    }

    public update(time, dt) {
        if(this._isTouchInProgress) {
            if(this._dragPauseTimer > 2) {
                this._handleRotationTween();
            }
            this._dragPauseTimer++;
        }
        else {
            if(!this._touchFlag){
                this._handleMovement(time, dt);
            }
        }
        this.target.speed = this.speed;
    }

    public start() {
        this._initInput();
    }

    public stop() {
        this._removeEvents();
    }
}